package fr.arcplex.network.model

/**
 * Unified rail (one line): the menu/fixed element or one ordered results rail.
 */
data class Rail(
    val id: String,
    val uid: String,
    val label: String? = null,
    val type: String = "",
    val height: Float = 60f,
    val focusable: Boolean? = null,
    val items: List<RailItem> = emptyList()
)
